import { useParams } from "react-router-dom";
import { getExam, useGetExamQuestionDetails } from "src/hooks/useExam";
import { useQuestionSettings } from "src/reducers/exam";

import OptionsList from "./index";

export function ExamOptionsList() {
	const { id } = useParams();
	const { question } = getExam(id);
	const { state, dispatch } = useQuestionSettings();
	const { data: details = {} } = useGetExamQuestionDetails(question.id, id);

	return (
		<OptionsList
			question={question}
			details={details}
			state={state}
			dispatch={dispatch}
		/>
	);
}
